const Footer = () => (
  <footer className="border-t border-border mt-16">
    <div className="container mx-auto px-6 lg:px-8 py-6 text-center text-sm text-muted-foreground">
      <p>
        © {new Date().getFullYear()} Guest House Sonja Krk · Website by{" "}
        <a
          href="https://www.linkedin.com/in/mateo-drglin-286286253/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-foreground hover:underline"
        >
          Mateo Drglin
        </a>
      </p>
    </div>
  </footer>
);

export default Footer;
